const snack = (state) => {
  return state.snackbar
}

const modal = (state) => {
  return state.modal
}

const nextSnackModal = (state) => {
  return state.queueSnackModal || []
}

export { snack, modal, nextSnackModal }
